module.exports = __webpack_public_path__ + "static/img/4.83b5d4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/eng/4.png
// module id = WfZi
// module chunks = 0